// Hand types for the tools S12 reads (map D-P12): they mirror the B9 shapes of PARALLEL-MAP §5 exactly, so the screens
// compile before frontend/src/api/tools.ts is regenerated at integration. S04 adds `closed_reason` to
// admin.archive_search and the `archived` status to requisition.list; S07 publishes the archive facts.

/** S04: `admin.archive_search` input gains `closed_reason: Literal["filled", "cancelled"] | None`. */
export type ClosedReason = "filled" | "cancelled";
export const CLOSED_REASONS: readonly ClosedReason[] = ["filled", "cancelled"];

export interface ArchiveSearchFilters {
  query?: string | null;
  level?: string | null;
  department?: string | null;
  owner_id?: string | null;
  archived_from?: string | null;
  archived_to?: string | null;
  closed_reason?: ClosedReason | null;
  limit?: number;
  cursor?: string | null;
}

/** One archive-search row: the V1 header keys and archive facts, plus what B9 reads when the row carries it. */
export interface ArchiveSearchItem {
  id: string;
  title?: string | null;
  status?: string | null;
  archived_at: string;
  archive_reason?: string | null;
  snapshot_id: string;
  /** S04: the close outcome the row was archived from. */
  closed_reason?: ClosedReason | null;
  /** S07's archive fact; absent on a row whose search output does not carry it yet. */
  content_hash?: string | null;
}

/** S07 (closeout.open `archive`): the facts of the latest retained snapshot. */
export interface ArchiveFacts {
  snapshot_id: string;
  archived_at: string;
  content_hash: string;
}

/** The status values `requisition.list` admits for the archived and closed outcomes (S04 adds `archived`). */
export type ClosedListStatus = "archived" | "filled" | "closed_filled" | "closed_cancelled" | "reopened";
